import { render } from "./UtilizeBonusAmountModal.vue?vue&type=template&id=56dc3aba"
import script from "./UtilizeBonusAmountModal.vue?vue&type=script&lang=js"
export * from "./UtilizeBonusAmountModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__